import React, { useState, useEffect } from 'react';
import Swaasa from "../Assets/images/Swaasa Logo.svg";
import LoginEllipse1 from "../Assets/images/login-ellipse-1.svg";
import LoginEllipse2 from "../Assets/images/login-ellipse-2.svg";
import LoginEllipse3 from "../Assets/images/login-ellipse-3.svg";
import GooglePlayStore from "../Assets/images/google-icon.svg";
import AppleIcon from "../Assets/images/apple-icon.svg";
import resetPassword from "../Assets/images/reset-password.png";
import Tick from  "../Assets/images/CheckCircle.svg";
import Cross from  "../Assets/images/XCircle.svg";
import ClipLoader from "react-spinners/ClipLoader";
import "../Assets/styles/newStyles/Login.css";
import axios from '../axios';
import { NotificationManager } from 'react-notifications';
import history from '../history';
import { useParams, useLocation } from 'react-router-dom';
import Eye from "../Assets/images/Eye.svg";
import EyeClosed from "../Assets/images/EyeClosed.svg";
 
const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [passwordValidations, setPasswordValidations] = useState({
    lowercase: false,
    uppercase: false,
    number: false,
    minLength: false,
  });
  const [successScreen, setSuccessScreen]= useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);

  useEffect(() => {
    localStorage.clear()
  })

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();
  const token = query.get('token');

  useEffect(() => {
    if (token) {
      localStorage.setItem('resetToken', token);
    }
  }, [token]);
 
  const goToSupport = () => {
    window.open("https://swaasa.ai/solutions/", "_blank");
  };

  const goToContactUs = () => {
    window.open("https://swaasa.ai/contact-us/", "_blank");
  };

  const goToPrivacyPolicy = () => {
    window.open("https://7jx.d89.myftpupload.com/privacy-policy/", "_blank");
  };

  const goToAppleStore = () => {
    window.open("https://apps.apple.com/us/app/swaasa/id1529923164", "_blank");
  };

  const goToGoogleStore = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.swaasa.app&hl=en&gl=US",
      "_blank"
    );
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const toggleShowPassword1 = () => {
    setShowPassword1(!showPassword1);
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setPasswordError("");

    setPasswordValidations({
      lowercase: /[a-z]/.test(newPassword),
      uppercase: /[A-Z]/.test(newPassword),
      number: /\d/.test(newPassword),
      minLength: newPassword.length >= 8,
    });
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    setConfirmPasswordError("");
  };

  const savePassword = async (e) => {
    e.preventDefault();
    localStorage.clear()
    if (password !== confirmPassword) {
      setConfirmPasswordError("Passwords did not match");
      return;
    }

    if (
      !passwordValidations.lowercase ||
      !passwordValidations.uppercase ||
      !passwordValidations.number ||
      !passwordValidations.minLength
    ) {
      setPasswordError("Password does not meet all the requirements");
      return;
    }

    setIsLoading(true);

    try {
      const formData = {
        token: token,
        password: password
      };

      const response = await axios.post('/v2/reset_password', formData);
      if (response.status === 200) {
        NotificationManager.success("Success", "Password Reset Done", 6000);
        setSuccessScreen(true);
      } else {
        NotificationManager.error("Error", "Please try again later", 6000);
        setSuccessScreen(false);
        setSuccessScreen(false);
      }
    } catch (error) {
      console.error(error);
      NotificationManager.error("Error", "Please try again later", 6000);
    } finally {
      setIsLoading(false);
      

    }
  };


  const returnToLogin=()=>{
   localStorage.clear()
   history.push('/')
  }


  return (
    <>
      <div className="main-login-container">
        <div className="header-container">
          <div>
            <img src={Swaasa} className="image-logo" alt="swaasa" />
          </div>
        </div>
        <div className="login-form-container">
          <img src={LoginEllipse2} className="login-ellipse2" alt="ellipse-2" />
          <div style={{ display: "flex" }}>
            {successScreen ? (
              <form className="form-container">
                <h1 className="forgot-heading">Password Saved Successfully</h1>
                <p className="forgot-text" style={{ margin: "5% 0 5% 0" }}>
                  Your password has been changed successfully.
                  <br />
                  You can now log in with new password.
                </p>
                <img
                  src={resetPassword}
                  alt="reset-password"
                  style={{ width: "120px", height: "120px" }}
                />
                <p style={{marginTop: '40px'}} className="forgot-text">You can Close this tab now / <span style={{cursor:'pointer', textDecoration: 'underline'}} onClick={returnToLogin}>Return to Login</span></p>
                {/* <button
                  className="send-reset-btn"
                  style={{ marginBottom: "0em", marginTop: "10%" }}
                  onClick={returnToLogin}
                >
                  Return to login
                </button> */}
              </form>
            ) : (
              <form className="form-container" onSubmit={savePassword}>
                <h1 className="forgot-heading">Reset Password</h1>
                <div className="input-container">
                  <div className='password-input-container'>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <label className="input-label" htmlFor="new-password">
                      New Password
                    </label>
                  </div>
                    <input
                      type={showPassword ? "text" : "password"}
                      id="new-password"
                      name="new-password"
                      className="password-input-field"
                      value={password}
                      onChange={handlePasswordChange}
                      placeholder="New Password"
                      required
                    />
                    <img
                        src={showPassword ? EyeClosed : Eye}
                        className="eye-icon"
                        alt="eye-icon"
                        onClick={toggleShowPassword}
                      />
                  </div>
                  <div className="password-requirements">
                    <div className="validations-psswd">
                    <div style={{display:'flex', alignItems:'center', gap:'3px'}}>
                      <img src={passwordValidations.lowercase?Tick:Cross}  alt='tick'/>
                      <p
                        className="lowercase-uppercase"
                        style={{
                          paddingTop:'1.5px',
                          textAlign:'center',
                          color: passwordValidations.lowercase
                            ? "green"
                            : "red",
                        }}
                      >
                         Lowercase
                      </p>
                      </div>
                      <div style={{display:'flex', alignItems:'center', gap:'3px'}}>
                      <img src={passwordValidations.uppercase?Tick:Cross}  alt='tick'/>
                      <p
                        className="lowercase-uppercase"
                        style={{
                          paddingTop:'1.5px',
                          textAlign:'center',
                          color: passwordValidations.uppercase
                            ? "green"
                            : "red",
                        }}
                      >
                         Uppercase
                      </p>
                      </div>

                    </div>
                    <div className="validations-psswd2">
                    <div style={{display:'flex', alignItems:'center', gap:'3px'}}>
                      <img src={passwordValidations.number?Tick:Cross}  alt='tick'/>
                      <p
                        className="lowercase-uppercase"
                        style={{
                          paddingTop:'1.5px',
                          textAlign:'center',
                          color: passwordValidations.number
                            ? "green"
                            : "red",
                        }}
                      >
                         Number
                      </p>
                      </div>
                      <div style={{display:'flex', alignItems:'center', gap:'3px'}}>
                      <img src={passwordValidations.minLength?Tick:Cross}  alt='tick'/>
                      <p
                        className="lowercase-uppercase"
                        style={{
                          paddingTop:'1.5px',
                          textAlign:'center',
                          color: passwordValidations.minLength
                            ? "green"
                            : "red",
                        }}
                      >
                        Characters Min.8
                      </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="input-container">
                  <div className='password-input-container'>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <label className="input-label" htmlFor="confirm-password">
                      Confirm Password
                    </label>
                    
                  </div>
                    <input
                      type={showPassword1 ? "text" : "password"}
                      id="confirm-password"
                      name="confirm-password"
                      className="password-input-field"
                      value={confirmPassword}
                      onChange={handleConfirmPasswordChange}
                      placeholder="Re-enter Password"
                      required
                    />
                    <img
                        src={showPassword1 ? EyeClosed : Eye}
                        className="eye-icon"
                        alt="eye-icon"
                        onClick={toggleShowPassword1}
                      />
                  </div>
                  {confirmPasswordError && (
                      <p className="error-password">{confirmPasswordError}</p>
                    )}
                    {passwordError && (
                      <p className="error-password">{passwordError}</p>
                    )}
                </div>
                {isLoading ? (
                  <div
                    className="send-reset-btn"
                    style={{ textAlign: "center", paddingTop: "8px" }}
                  >
                    <ClipLoader color="white" size={25} />
                  </div>
                ) : (
                  <button
                    type="submit"
                    className="send-reset-btn"
                    style={{ marginBottom: "0em", marginTop: "5%" }}
                  >
                    Save
                  </button>
                )}
                <div className="sign-up-forgot" style={{marginTop:'10%'}}>
                  <p className="signup-para" style={{ fontSize: "14px" }}>
                    Remember Password? {''}
                    <span onClick={returnToLogin} style={{ fontWeight: "500", color: "#FF7D00", cursor:'pointer' }}>
                      Go back to login
                    </span>
                  </p>
                </div>
              </form>
            )}
            <img
              src={LoginEllipse3}
              alt="login-ellipse3"
              className="login-ellipse3"
            />
          </div>
          <img src={LoginEllipse1} className="login-ellipse1" alt="ellipse-1" />
        </div>
        <div className="footer-container">
          <div className="get-containers">
            <div className="get-container">
              <img
                src={GooglePlayStore}
                className="support-image"
                alt="google"
                onClick={goToGoogleStore}
              />
              <img
                src={AppleIcon}
                onClick={goToAppleStore}
                className="support-image"
                alt="apple"
              />
            </div>
          </div>
          <div className="support-containers">
            <h4 className="support-heading" onClick={goToSupport}>
              SUPPORT
            </h4>
            <h4 className="support-heading" onClick={goToContactUs}>
              CONTACT US
            </h4>
            <h4 className="support-heading" onClick={goToPrivacyPolicy}>
              PRIVACY POLICY
            </h4>
            <h4 className="support-heading" onClick={goToPrivacyPolicy}>
              TERMS & CONDITIONS
            </h4>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
